export const BROCHURE_NOT_FOUND = "BROCHURE_NOT_FOUND";
